import React from 'react';
import { Shield, Lock, AlertTriangle, FileText } from 'lucide-react';
import './LegalPages.css';

function TermsOfService() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <img src="/logo.png" alt="Logo" className="legal-logo" />
          <FileText size={48} />
          <h1>Conditions Générales d'Utilisation</h1>
          <p className="legal-subtitle">Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')}</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2><Shield size={24} /> 1. Acceptation des conditions</h2>
            <p>
              En accédant et en utilisant le panel de maintenance Discord Maintenance Panel, 
              vous acceptez d'être lié par ces Conditions Générales d'Utilisation. 
              Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser ce service.
            </p>
          </section>

          <section className="legal-section">
            <h2><Lock size={24} /> 2. Description du service</h2>
            <p>
              Discord Maintenance Panel est un service de gestion de maintenance pour serveurs Discord 
              qui permet aux administrateurs autorisés de gérer les statuts de maintenance de leurs serveurs. 
              Le service utilise l'authentification Discord OAuth2 et vérifie les permissions administrateur.
            </p>
          </section>

          <section className="legal-section">
            <h2><AlertTriangle size={24} /> 3. Obligations de l'utilisateur</h2>
            <ul>
              <li>Ne pas utiliser le service à des fins illégales ou non autorisées</li>
              <li>Ne pas tenter d'accéder à des serveurs sans les permissions administrateur requises</li>
              <li>Ne pas perturber le fonctionnement normal du service</li>
              <li>Ne pas introduire de virus, malware ou code malveillant</li>
              <li>Respecter les conditions d'utilisation de Discord</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2><Shield size={24} /> 4. Propriété intellectuelle</h2>
            <p>
              Tout le contenu, les fonctionnalités et la conception de Discord Maintenance Panel 
              sont la propriété exclusive de ses créateurs et sont protégés par les lois 
              sur la propriété intellectuelle.
            </p>
          </section>

          <section className="legal-section">
            <h2><Lock size={24} /> 5. Limitation de responsabilité</h2>
            <p>
              Discord Maintenance Panel est fourni "tel quel" sans aucune garantie. 
              Nous ne sommes pas responsables des dommages directs, indirects, 
              accidentels ou consécutifs résultant de l'utilisation de ce service.
            </p>
          </section>

          <section className="legal-section">
            <h2><AlertTriangle size={24} /> 6. Modifications des conditions</h2>
            <p>
              Nous nous réservons le droit de modifier ces conditions à tout moment. 
              Les modifications prendront effet dès leur publication sur cette page.
            </p>
          </section>

          <section className="legal-section">
            <h2><Shield size={24} /> 7. Loi applicable</h2>
            <p>
              Ces conditions sont régies par les lois en vigueur. 
              Tout litige sera soumis aux tribunaux compétents.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
